import type { FC } from 'react';
import React from 'react';
import type { StyleProp, ImageStyle, ColorValue } from 'react-native';
import { View } from 'react-native';
import { IconLoader } from '@thermenresorts/icons';
import type { SvgProps } from 'react-native-svg';
import Dimens from 'src/core/utils/Dimens';

type IconProps = {
	name: string;
	size?: number | undefined;
	style?: StyleProp<ImageStyle>;
	tintColor?: ColorValue | undefined;
};

type SvgIconStyle = Omit<ImageStyle, 'flex'> & {
	flex?: ImageStyle['flex'] | 'none';
	color?: ColorValue;
};

type SvgIconComponent = FC<Omit<SvgProps, 'style'> & { style?: SvgIconStyle }>;

const loader = new IconLoader();

const SvgIcon = ({ name, size = Dimens.iconSize24, style, tintColor }: IconProps) => {
	if (!name || typeof name !== 'string') {
		return <View style={[{ width: size, height: size }, style]} />;
	}

	const svg: unknown = loader.getSvg(name);

	if (typeof svg !== 'function') {
		return <View style={[{ width: size, height: size }, style]} />;
	}

	const SvgComponent = svg as SvgIconComponent;

	return (
		<SvgComponent
			height={size}
			style={{ ...style, ...(tintColor ? { color: tintColor } : {}), flex: 'none' }}
			width={size}
		/>
	);
};

export default SvgIcon;
